import {
  contrastForeground,
  normalizeTenantTheme,
  resolveTenantAccent,
  tenantBaseFontSizeCss,
} from './tenantTheme';
import { focusOutlineCssVars } from './focusOutline.js';
import type { TenantTheme } from '../types';

const THEME_CSS_VARS = [
  '--accent-primary',
  '--accent',
  '--accent-fg',
  '--slot-picker-tray-ring',
  '--focus-outline-width',
  '--focus-outline-offset',
  '--sf-font-size-base',
] as const;

function accentRingColor(accent: string): string {
  const hex = accent.replace('#', '');
  if (hex.length !== 6) return 'rgba(37, 99, 235, 0.12)';
  const r = Number.parseInt(hex.slice(0, 2), 16);
  const g = Number.parseInt(hex.slice(2, 4), 16);
  const b = Number.parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, 0.12)`;
}

/** Apply tenant accent + base type size to document CSS variables (storefront + app shell). */
export function applyTenantThemeCss(theme: TenantTheme | unknown) {
  const normalized = normalizeTenantTheme(theme);
  const accent = resolveTenantAccent(normalized);
  const root = document.documentElement;
  const focusCss = focusOutlineCssVars({
    widthPx: normalized.focusOutlineWidthPx,
    offsetPx: normalized.focusOutlineOffsetPx,
  });

  root.style.setProperty('--accent-primary', accent);
  root.style.setProperty('--accent', accent);
  root.style.setProperty('--accent-fg', contrastForeground(accent));
  root.style.setProperty('--slot-picker-tray-ring', accentRingColor(accent));
  root.style.setProperty('--focus-outline-width', focusCss.width);
  root.style.setProperty('--focus-outline-offset', focusCss.offset);
  root.style.setProperty('--sf-font-size-base', tenantBaseFontSizeCss(normalized.baseFontScale));
}

export function clearTenantThemeCss() {
  const root = document.documentElement;
  for (const name of THEME_CSS_VARS) {
    root.style.removeProperty(name);
  }
}
